import "./PriceSelector.css";
import { useTranslation } from "react-i18next";

const PriceSelector = ({
    onChange,
    isGray,
    priceList,
    isValid,
    defaultValue,
}) => {
    const { t } = useTranslation("priceSelectorDisplay");

    let priceSelectorClass = "PriceSelector";
    let priceDisplay = <></>;

    if (priceList && priceList.length > 1) {
        let priceComponent = [];

        priceList.forEach((element) => {
            let elementToPush = (
                <option key={element} value={element}>
                    {t("price", { price: element + " Bits" })}
                </option>
            );

            priceComponent.push(elementToPush);
        });

        priceDisplay = priceComponent;
    } else {
        priceDisplay = (
            <option value="0">{t("price", { price: "0 Bits" })}</option>
        );
        isGray = true;

        if (!isValid)
            priceDisplay = <option value="0">{t("invalidPrice")}</option>;
    }

    if (isGray) priceSelectorClass = "PriceSelectorClassIsGray";

    return (
        <>
            <select
                className={priceSelectorClass}
                name="price"
                defaultValue={defaultValue}
                onChange={onChange}
            >
                {priceDisplay}
            </select>
        </>
    );
};

export default PriceSelector;
